import { Grid } from "@mui/material";
import { RouteComponentProps } from "@reach/router";
import CardHESP from "../../components/CardHESP/CardHESP";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import gql from "graphql-tag";
import ManageReportForm from "../../components/Reports/ManageReportForm";

interface Props extends RouteComponentProps {
    organizationId?: string;
}

export const GET_REPORT_QUERY = gql`
    query GetReportQuery($reportId: ID!, $organizationId: ID!) {
        report(reportId: $reportId, organizationId: $organizationId) {
            reportId
            name
            start
            end
            channelIds
            organizationId
            clientId
            reportGenerated
            metadata {
                key
                value
            }
        }
    }
`;

export default function CreateReport({ organizationId }: Props) {
    return (
        <Grid container spacing={{ xs: 5, md: 6 }} justifyContent="center">
            <Grid item xs={12}>
                <SectionTitle title="Create a report" align="left" showBottomBorder />
                <CardHESP>
                    <ManageReportForm organizationId={organizationId!} />
                </CardHESP>
            </Grid>
        </Grid>
    );
}
